import { render, staticRenderFns } from "./TaskCenter.vue?vue&type=template&id=11e427aa"
import script from "./TaskCenter.vue?vue&type=script&lang=js"
export * from "./TaskCenter.vue?vue&type=script&lang=js"
import style0 from "./TaskCenter.vue?vue&type=style&index=0&id=11e427aa&prod&lang=less"


/* normalize component */
import normalizer from "!D:\\Code\\ui\\comic_ai\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports